import { Roles } from "../app/Roles";
import keycloak from "../Keycloak";

export const MapUser = (beUser: any) => {
    const user = beUser;

    if (keycloak.realmAccess?.roles?.length) {
        for (const role of keycloak.realmAccess?.roles || []) {
            if(!user.roles){
                user.roles = ["SUMMARY"] as Roles[];
            }
            user.roles.push(role);
        }
    }

    if(user.roles && user.roles.length === 0){
        user.roles = ["SUMMARY"] as Roles[];
    }

    return user;
}
